import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { RestaurantsPage } from './pages/RestaurantsPage';
import { HotelsPage } from './pages/HotelsPage';
import { CafesPage } from './pages/CafesPage';
import { WellnessPage } from './pages/WellnessPage';
import { CondominiumsPage } from './pages/CondominiumsPage';
import { RetailPage } from './pages/RetailPage';
import { FranchisePage } from './pages/FranchisePage';
import { ScrollToTop } from './components/ScrollToTop';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <ScrollToTop data-id="element-13" />
      <Routes data-id="element-14">
        <Route path="/" element={<App data-id="element-16" />} data-id="element-15" />
        <Route path="/restaurants" element={<RestaurantsPage data-id="element-18" />} data-id="element-17" />
        <Route path="/hotels" element={<HotelsPage data-id="element-20" />} data-id="element-19" />
        <Route path="/cafes" element={<CafesPage data-id="element-22" />} data-id="element-21" />
        <Route path="/wellness" element={<WellnessPage data-id="element-24" />} data-id="element-23" />
        <Route path="/condominiums" element={<CondominiumsPage data-id="element-26" />} data-id="element-25" />
        <Route path="/retail" element={<RetailPage data-id="element-28" />} data-id="element-27" />
        <Route path="/franchise" element={<FranchisePage data-id="element-30" />} data-id="element-29" />
      </Routes>
    </BrowserRouter>;
}